import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from './../layout/Dashboard';
import { hideNotification } from '../../store/actions/notification';
import { ClientsTable } from "../../components/pages/clients/ClientsTable";
import { Messages } from "../../components/layout/Messages/Messages";
import { NOTIFICATION_CLIENT_ACTIONS, NOTIFICATION_SEND_EMAIL_USER } from '../../config/notifications';
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './Clients.scss';

function ClientsComponent(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="clients-list-workspace">
        <PageHeader title={<FormattedMessage id="pages.clients.title"/>}/>
        <div className="clients-list-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_CLIENT_ACTIONS}/>
          <Messages notificationId={NOTIFICATION_SEND_EMAIL_USER}/>
        </div>
        <PageSurface className="clients-list-surface">
          {! ACL.CLIENT.USERS.LIST.hasAccess() ? <NoRights/> :
            <ClientsTable/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const mapStateToProps = state => ( {} );

const Clients = connect( mapStateToProps, { hideNotification } )( ClientsComponent );

export { Clients, ClientsComponent };
